<template>
  <div class="wizard-panel keywords-wizard-panel">
    <div class="wizard-card">
      <div class="wizard-card-content">
        <div v-if="!isExamples">
          <h2>BRAND KEYWORDS</h2>
          <p>Enter a few words that describe your brand.</p>
          <p>
            <span>Not sure what to use?&emsp;&emsp;</span>
            <button class="btn pale-teal" @click="toggleExamples">See examples</button>
          </p>
        </div>
        <div v-if="isExamples">
          <keywords-examples @close="toggleExamples"/>
        </div>
        <button class="prev-step-btn" @click="prevStep">
          <svg xmlns="http://www.w3.org/2000/svg" width="7.511" height="12.281" viewBox="0 0 7.511 12.281">
            <path d="M4584.929,3710.355l-2.047,2.047c-2.523,2.523-2.731,2.754-2.731,2.754s.208.2,2.743,2.732l2.06,2.06-.316.316-.329.327c-.475-.471-1.455-1.446-2.736-2.728l-2.716-2.716,2.707-2.708c1.278-1.277,2.254-2.249,2.728-2.718C4584.385,3709.811,4584.929,3710.355,4584.929,3710.355Z" transform="translate(-4578.15 -3709.016)" fill="#fff" stroke="#fff" stroke-miterlimit="10" stroke-width="1"/>
          </svg>&emsp;&emsp;
          Back
        </button>
      </div>
    </div>
    <div class="wizard-card">
      <div class="wizard-card-content">
        <div>
          <input-tag v-model="brandKeywords" ref="inputTag"></input-tag>
        </div>
        <keywords-ideas @selectKeyword="addKeyword"/>
        <div class="wizard-card-actions">
          <button class="prev-step-big-btn" @click="prevStep">
            <svg xmlns="http://www.w3.org/2000/svg" width="7.511" height="12.281" viewBox="0 0 7.511 12.281">
              <path d="M4584.929,3710.355l-2.047,2.047c-2.523,2.523-2.731,2.754-2.731,2.754s.208.2,2.743,2.732l2.06,2.06-.316.316-.329.327c-.475-.471-1.455-1.446-2.736-2.728l-2.716-2.716,2.707-2.708c1.278-1.277,2.254-2.249,2.728-2.718C4584.385,3709.811,4584.929,3710.355,4584.929,3710.355Z" transform="translate(-4578.15 -3709.016)" stroke-miterlimit="10" stroke-width="1"/>
            </svg>&emsp;
            Back
          </button>
          <button @click="nextStep" class="btn btn-big next-step-big-btn" :disabled="!isCurrStepValid">
            Next&emsp;&emsp;
            <svg xmlns="http://www.w3.org/2000/svg" width="9.191" height="14.718" viewBox="0 0 9.191 14.718">
              <path d="M2156.239,749.889l2.373-2.373c2.924-2.925,3.166-3.192,3.166-3.192s-.242-.228-3.181-3.167l-2.388-2.388.367-.366c.147-.148.275-.275.381-.379.551.545,1.687,1.676,3.172,3.161l3.149,3.149-3.139,3.139c-1.481,1.481-2.613,2.608-3.163,3.152C2156.869,750.519,2156.239,749.889,2156.239,749.889Z" transform="translate(-2155.148 -736.966)" fill="#fff" stroke="#fff" stroke-miterlimit="10" stroke-width="1.5"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'
import InputTag from 'vue-input-tag'
import KeywordsExamples from '@/components/Wizard/KeywordsExamples.vue'
import KeywordsIdeas from '@/components/Wizard/KeywordsIdeas.vue'

export default {
  name: 'BrandKeywords',
  components: {
    InputTag,
    KeywordsExamples,
    KeywordsIdeas,
  },
  props: {
    item: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      isExamples: false,
    }
  },
  computed: {
    ...mapGetters('wizard', [
      'currStep',
      'isCurrStepValid',
    ]),
    brandKeywords: {
      get () {
        return this.$store.state.wizard.brandKeywords
      },
      set (value) {
        return this.$store.commit('wizard/SET_BRAND_KEYWORDS', value)
      }
    },
  },
  methods: {
    ...mapActions('wizard', [
      'nextStep',
      'prevStep',
    ]),
    toggleExamples() {
      this.isExamples = !this.isExamples;
    },
    addKeyword(keyword) {
      this.$store.commit('wizard/ADD_BRAND_KEYWORD', keyword);
    }
  },
  mounted() {
    /**
     * Add tricky event listener for internal new-tag input inside vue-input-tag
     * On input event commit changes to vuex store
     */
    this.$refs.inputTag.$refs.inputtag.addEventListener('keyup', (e) => {
      this.$store.commit('wizard/SET_NEW_KEYWORD', e.target.value);
      console.warn(e.target.value);
    })
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

.wizard-panel {
  z-index: 3;
}

.wizard-card:nth-child(1) {
  background-color: $pale-teal;
}

.keywords-wizard-panel {

  .wizard-card:nth-child(2) {
    align-items: flex-start;

    .wizard-card-content {
      display: flex;
      flex-direction: column;
      min-height: 56.5%;

      & > div:nth-child(2) {
        order:-1;
      }
    }
  }
}

.next-step-big-btn {
  background-color: $barbie-pink;

  &:disabled {
    background-color: $very-light-pink;
  }
}

.prev-step-big-btn {
  color: $pale-teal;
}

@media (orientation: portrait) and (max-width: 576px) {
  .keywords-wizard-panel {

  .wizard-card:nth-child(1) {
    padding-top: 3em;
  }

  .wizard-card:nth-child(2) {

    .wizard-card-content {

      & > div:nth-child(2) {
        order:0;
      }
    }
  }
}
}

@media (min-width: 768px) {
  .keywords-wizard-panel {

  .wizard-card:nth-child(2) {
    align-items: flex-end;

    .wizard-card-content {
      & > div:nth-child(2) {
        order:0;
      }
    }
  }
}
}

@media (min-width: 768px) {
  .wizard-panel {

    &.active .wizard-card:nth-child(1),
    .wizard-card:nth-child(1) {
      padding: 2em;
      padding-left: calc(55% + 2em);
    }
  }
}

@media (min-width: 1200px) {
  .wizard-panel {

    .wizard-card:nth-child(1) {
      padding: 5em;
      padding-left: calc(55% + 5em);
    }
  }
}
</style>
